/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */
import * as actionTypes from '../constants/action-types';

const SCREEN_ACTIVATED = '1';
const SCREEN_NOT_STARTED = '0';
const SCREEN_FORCED = '2';

const setActivatedWelcomeTour = (value = SCREEN_ACTIVATED) => localStorage.setItem('welcomeModal', value);
export const isWelcomeModalBeenActivated = () => localStorage.getItem('welcomeModal') === SCREEN_ACTIVATED;
export const isWelcomeModalForced = () => localStorage.getItem('welcomeModal') === SCREEN_FORCED;
export const forceWelcomeModal = () => localStorage.setItem('welcomeModal', SCREEN_FORCED);

export const openWelcomeModal = () => (dispatch) => {
  setActivatedWelcomeTour(SCREEN_NOT_STARTED);
  return dispatch({type: actionTypes.OPEN_WELCOME_MODAL})
};

export const closeWelcomeModal = (dispatch) => {
  setActivatedWelcomeTour();
  return dispatch({type: actionTypes.CLOSE_WELCOME_MODAL})
};

